import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Kharghartopunecab() {



const cardData = {
  keyword: " Kharghar to Pune Cabs ",

headingDescription: "Velocity Cab provides reliable and comfortable Kharghar to Pune cab services, ensuring a smooth and hassle-free journey for business trips, airport transfers, family outings, and leisure travel. Our professional drivers, well-maintained vehicles, and punctual pickups make traveling from Kharghar to Pune convenient and stress-free. We offer flexible booking options including one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, and luxury cars suitable for solo travelers, families, and corporate clients. With easy online booking and 24/7 customer support, Velocity Cab is the trusted choice for Kharghar to Pune cab travel.",

topPlaces: [
  {
    title: "Pune Okayama Friendship Garden",
    description: "Pune Okayama Friendship Garden, also known as Pu La Deshpande Garden, is a beautifully landscaped Japanese-style garden featuring serene ponds, lush greenery, and elegant walking paths. Travelers booking a sedan cab in Pune can enjoy peaceful strolls, scenic photography, and a relaxing escape from the city's busy streets."
  },
  {
    title: "Saras Baug",
    description: "Saras Baug is a popular recreational garden in Pune featuring beautifully maintained lawns and the famous Siddhivinayak Temple. Visitors can relax amidst nature, enjoy leisurely walks, and experience one of the city's favorite family-friendly destinations."
  },
  {
    title: "Raja Dinkar Kelkar Museum",
    description: "Raja Dinkar Kelkar Museum is home to thousands of rare artifacts, traditional musical instruments, sculptures, and decorative objects representing India's rich cultural heritage. It offers an enriching experience for history and art enthusiasts."
  },
  {
    title: "Aga Khan Palace",
    description: "Aga Khan Palace is a magnificent heritage monument associated with India's freedom movement. Visitors can explore its elegant architecture, peaceful gardens, and museum dedicated to Mahatma Gandhi while learning about Pune's historical significance."
  },
  {
    title: "Pataleshwar Cave Temple",
    description: "Pataleshwar Cave Temple is an ancient rock-cut Shiva temple carved from a single basalt rock. Its tranquil surroundings and remarkable architecture make it a popular destination for spirituality, history, and photography."
  },
  {
    title: "Bund Garden",
    description: "Bund Garden is a scenic riverside park offering lush greenery, boating opportunities, and peaceful walking paths. It is a perfect place for families, couples, and nature lovers seeking relaxation."
  },
  {
    title: "Parvati Hill",
    description: "Parvati Hill is one of Pune's oldest landmarks, offering panoramic city views from its historic temple complex. Travelers can climb the stone steps, visit ancient shrines, and enjoy breathtaking scenery."
  },
  {
    title: "Shaniwar Wada",
    description: "Shaniwar Wada is Pune's iconic historical fort and a symbol of the Maratha Empire. Visitors can explore its grand gateways, historic ruins, and captivating light and sound show that showcases the city's rich heritage."
  },
  {
    title: "Phoenix Marketcity Pune",
    description: "Phoenix Marketcity Pune is a premier shopping and entertainment destination featuring international brands, restaurants, cinemas, and family-friendly attractions, making it ideal for a day of leisure."
  },
  {
    title: "Khadakwasla Dam",
    description: "Khadakwasla Dam is a scenic getaway on the outskirts of Pune, popular for its peaceful waterfront views, beautiful sunsets, and relaxing atmosphere. It is an excellent destination for picnics and photography."
  }
],



services: [
{
name: "Kharghar to Pune Taxi",
description: "Kharghar to Pune taxi service offers a smooth and reliable travel experience from Navi Mumbai to Pune via the Mumbai–Pune Expressway. This route is widely preferred by corporate travelers, IT professionals, and families for its fast connectivity and scenic drive. Travelers can choose from sedan, Ertiga, and Innova Crysta vehicles based on comfort and group size. Professional drivers ensure timely pickup from Kharghar sectors, CIDCO areas, and nearby locations. The service includes clean, air-conditioned vehicles with ample luggage space for long-distance journeys. Online booking with instant confirmation and transparent pricing ensures a hassle-free travel experience. Whether it’s a business trip or a weekend getaway, this service guarantees comfort and reliability."
},
{
name: "Kharghar to Pune Cab Cost",
description: "Kharghar to Pune cab cost depends on vehicle type, travel mode, and timing, offering flexible pricing for every budget. Sedan options are economical, while Ertiga and Innova Crysta provide premium comfort for families and groups. Transparent fare details include toll charges, driver allowance, and per km rates, ensuring no hidden costs. Customers can easily compare pricing and select the best option for one-way or round trip travel. This helps in planning travel budgets effectively while ensuring a comfortable journey."
},
{
name: "Bandra Kurla Complex to Pune Cab",
description: "Bandra Kurla Complex to Pune cab service offers premium travel for corporate professionals and business travelers. With direct pickup from BKC offices and commercial hubs, this service ensures timely and comfortable travel to Pune. Luxury vehicles like Innova Crysta are ideal for executives seeking a smooth and professional travel experience."
},
{
name: "Mahim to Pune Cab Fare",
description: "Mahim to Pune cab fare service provides clear and affordable pricing for travelers commuting between Mahim and Pune. Passengers can choose from budget sedan options to premium SUVs depending on their needs. Transparent pricing ensures a stress-free booking experience."
},
{
name: "Kanjurmarg to Pune Cab",
description: "Kanjurmarg to Pune cab service offers reliable and comfortable travel between Mumbai suburbs and Pune city. With easy pickup from residential and commercial areas, this service ensures convenience and timely travel."
},
{
name: "Mumbra to Pune Cab Service",
description: "Mumbra to Pune cab service provides dependable intercity travel with comfortable vehicles and experienced drivers. Travelers can enjoy smooth highway rides with flexible pickup and drop options."
},
{
name: "Vikhroli to Pune Cab Service",
description: "Vikhroli to Pune cab service offers safe and comfortable travel with professional drivers and well-maintained vehicles. This service is ideal for both daily commuters and occasional travelers."
},
{
name: "Kharghar to Pune One Way Cab",
description: "Kharghar to Pune one way cab service provides cost-effective travel for passengers requiring single-direction trips. It is perfect for airport transfers, office travel, and quick intercity journeys without return charges."
},
{
name: "Kharghar to Pune Round Trip Cab",
description: "Kharghar to Pune round trip cab service offers flexible return travel options for families and business travelers. Customers can book vehicles for multi-day trips with convenient return scheduling."
},
{
name: "Kalina to Pune Cab",
description: "Kalina to Pune cab service provides direct and comfortable travel from Kalina area in Mumbai to Pune. This service is widely used by professionals and students traveling between the two cities."
},
{
name: "Cab Service in Kharghar Mumbai",
description: "Cab service in Kharghar provides reliable transportation for local travel, airport transfers, and outstation journeys. Travelers can choose from a wide range of vehicles with experienced drivers."
},
{
name: "Ertiga Cab in Kharghar Mumbai",
description: "Ertiga cab in Kharghar offers spacious and comfortable travel for families and groups. It is ideal for long-distance journeys like Kharghar to Pune with ample seating and luggage space."
},
{
name: "Ertiga Taxi Fare in Kharghar",
description: "Ertiga taxi fare in Kharghar provides affordable pricing for 6–7 seater travel. It is a popular choice for group travel due to its balance of cost and comfort."
},
{
name: "Innova Cab in Kharghar",
description: "Innova cab in Kharghar offers premium SUV travel with enhanced comfort and spacious seating. It is ideal for corporate travel and long-distance journeys like Pune trips."
},
{
name: "Kharghar Cab Service",
description: "Kharghar cab service provides dependable transportation for city rides, airport transfers, and outstation travel. Travelers can enjoy safe and convenient travel with professional drivers."
},
{
name: "Outstation Cab Service in Kharghar",
description: "Outstation cab service in Kharghar offers long-distance travel to Pune, Lonavala, Nashik, and more. Travelers can book comfortable vehicles with experienced drivers for safe journeys."
},
{
name: "Best Taxi Service in Kharghar",
description: "Best taxi service in Kharghar ensures high-quality travel with clean vehicles, professional drivers, and timely pickups. It is ideal for both local and outstation travel needs."
},
{
name: "Kharghar to Pune Cab",
description: "Kharghar to Pune cab service offers reliable intercity transportation with comfortable vehicles and smooth highway connectivity."
},
{
name: "Kharghar to Pune Cabs",
description: "Kharghar to Pune cabs provide convenient and safe travel options with professional drivers and well-maintained vehicles."
},
{
name: "Kharghar to Pune Cab Service",
description: "Kharghar to Pune cab service ensures comfortable and hassle-free travel with flexible pickup options and transparent pricing."
},
{
name: "Kharghar to Pune Taxi Service",
description: "Kharghar to Pune taxi service offers dependable travel with experienced drivers and comfortable vehicles for a pleasant journey."
},
{
name: "Kharghar to Pune One Way Cab",
description: "Kharghar to Pune one way cab service provides affordable single-direction travel without return charges."
},
{
name: "Kharghar to Pune Taxi Fare",
description: "Kharghar to Pune taxi fare provides transparent pricing helping travelers plan their travel budget efficiently."
},
{
name: "Kharghar to Pune Cab Booking",
description: "Kharghar to Pune cab booking allows passengers to reserve taxis online with instant confirmation and flexible schedules."
}
],

tableData: [
["Kharghar to Pune Taxi","Kharghar to Pune Cab Cost"],
["Bandra Kurla Complex to Pune Cab","Mahim to Pune Cab Fare"],
["Kanjurmarg to Pune Cab","Mumbra to Pune Cab Service"],
["Vikhroli to Pune Cab Service","Kharghar to Pune One Way Cab"],
["Kharghar to Pune Round Trip Cab","Kalina to Pune Cab"],
["Cab Service in Kharghar Mumbai","Ertiga Cab in Kharghar Mumbai"],
["Ertiga Taxi Fare in Kharghar","Innova Cab in Kharghar"],
["Kharghar Cab Service","Outstation Cab Service in Kharghar"],
["Best Taxi Service in Kharghar","Kharghar to Pune Cab"],
["Kharghar to Pune Cabs","Kharghar to Pune Cab Service"],
["Kharghar to Pune Taxi Service","Kharghar to Pune One Way Cab"],
["Kharghar to Pune Taxi Fare","Kharghar to Pune Cab Booking"]
],




whychoose: [
  {
    WhyChooseheading: "Experienced Expressway Drivers",
    WhyChoosedescription: "Velocity Cabs provides experienced drivers who regularly travel from Kharghar to Pune via the Mumbai Pune Expressway. Their knowledge of highway routes and traffic conditions ensures safe and timely intercity travel."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Velocity Cabs offers transparent and affordable pricing for Kharghar to Pune cab bookings. Customers receive clear fare details including toll charges and driver allowance before confirming the ride."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our Kharghar to Pune cab service operates 24 hours a day. Whether you need an early morning ride, business travel, airport transfer, or late night ride, Velocity Cabs ensures reliable transportation anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in the Velocity Cabs fleet are fully air-conditioned, well maintained, and regularly cleaned to provide passengers with a comfortable long-distance travel experience."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Velocity Cabs offers flexible travel options including one-way cab service, round-trip bookings, airport transfers, and customized travel plans from Kharghar to Pune."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Velocity Cabs offers a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers suitable for individuals, families, and corporate travelers."
  },
  {
    WhyChooseheading: "Doorstep Pickup in Kharghar",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, offices, railway stations, and residential areas across Kharghar including Sector 4, Sector 7, Sector 10, and nearby Navi Mumbai locations."
  },
  {
    WhyChooseheading: "Trusted Intercity Cab Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many travelers for Kharghar to Pune cab bookings thanks to punctual drivers, comfortable vehicles, and professional intercity travel service."
  }
]
};

const faqData = [
  { question: "Do you provide Kharghar to Pune cab service?", answer: "Yes, Velocity Cabs provides reliable cab services from Kharghar to Pune with professional drivers and comfortable vehicles." },
  { question: "How far is Kharghar from Pune?", answer: "The road distance between Kharghar and Pune is approximately 120 km and the journey usually takes about 2.5 to 3 hours depending on traffic." },
  { question: "Is Kharghar to Pune cab service available 24 hours?", answer: "Yes, our cab service operates 24/7 to match customer travel schedules." },
  { question: "Which vehicles are available for Kharghar to Pune travel?", answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers." },
  { question: "Can I book a one-way cab from Kharghar to Pune?", answer: "Yes, we provide both one-way and round-trip cab services between Kharghar and Pune." },
  { question: "Do you provide pickup from homes and hotels?", answer: "Yes, our drivers provide doorstep pickup from homes, hotels, offices, railway stations, and residential areas across Kharghar." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Velocity Cabs are fully air-conditioned for comfortable long-distance travel." },
  { question: "Can I book the cab online?", answer: "Yes, customers can easily book Kharghar to Pune cab services online or through phone booking." },
  { question: "Do you provide drop service to Pune Airport or railway station?", answer: "Yes, Velocity Cabs provides drop services to Pune Airport, railway stations, and major locations across Pune." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Avinash Patil",
    feedback:
      "Starting from Kharghar, the Pune trip was very well organized. The cab was comfortable, the timing was perfect, and the journey felt smooth and relaxed throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Deshmukh",
    feedback:
      "From Kharghar to Pune, the travel experience was really pleasant. The vehicle was clean, the ride was steady, and everything was managed in a very professional way.",
    rating: 5
  }
];





























const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];












const khargharToPuneJSON = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Kharghar to Pune Cab Service | Velocity Cabs",
  "description": "Book reliable Kharghar to Pune cab with Velocity Cabs. Cars available: Innova, Sedan, Ertiga. One-way, round trips, and outstation taxi options at affordable fares.",
  "provider": {
    "@type": "Organization",
    "name": "Velocity Cabs",
    "url": "https://www.velocitycabs.com/"
  },
  "areaServed": {
    "@type": "Place",
    "name": "Kharghar, Navi Mumbai, Maharashtra, India"
  },
  "serviceType": [
    "Kharghar to Pune Taxi",
    "One-way Cab Kharghar to Pune",
    "Round Trip Cab Service",
    "Outstation Taxi",
    "AC Taxi Service"
  ],
  "offers": {
    "@type": "Offer",
    "url": "https://www.velocitycabs.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  }
};





  return (
    <div>
      <Helmet>
  <title>Kharghar to Pune Cab Service | Velocity Cabs +91 9136271336</title>
  <meta
    name="description"
    content="Book reliable Kharghar to Pune cab with Velocity Cabs. Innova, Sedan, Ertiga available for one-way, round trip, and outstation taxi options at affordable fares."
  />
  <script type="application/ld+json">
    {JSON.stringify(khargharToPuneJSON)}
  </script>
</Helmet>



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/64.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Kharghartopunecab;